<template>
  <div class="user-view container is-max-desktop">
    <div class="box is-primary">
      <h2 class="title is-3">
        {{ newUser ? "Registrér Ny Bruger" : "Redigér Bruger" }}
      </h2>

      <!-- Personal info -->
      <section class="personal-info">
        <div class="columns">
          <b-field label="Nummer" class="column">
            <b-input v-model="formAppUser.number" type="number"></b-input>
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Fornavn" class="column">
            <b-input v-model="formAppUser.givenName" />
          </b-field>
          <b-field label="Efternavn" class="column">
            <b-input v-model="formAppUser.surName" />
          </b-field>
        </div>

        <div class="columns">
          <b-field label="Addresse" class="column">
            <b-input v-model="formAppUser.address" />
          </b-field>
        </div>

        <div class="columns">
          <b-field label="By" class="column">
            <b-input v-model="formAppUser.city" />
          </b-field>
          <b-field label="Sted" class="column">
            <b-input v-model="formAppUser.place" />
          </b-field>
        </div>

        <div class="phone-numbers">
          <div class="columns">
            <b-field label="Arbejdsnummer" class="column">
              <b-input v-model="formAppUser.phoneWork" />
            </b-field>
            <b-field label="Mobilnummer" class="column">
              <b-input v-model="formAppUser.mobilePhone" />
            </b-field>
          </div>

          <div class="columns">
            <b-field label="Privatnummer" class="column">
              <b-input v-model="formAppUser.phonePrivate" />
            </b-field>
          </div>
        </div>
      </section>

      <!-- 
  Address
  Place
  ZipCode
  PhoneWork
  PhonePrivate
  MobilePhone
 -->

      <!-- App specific info -->
      <section class="domain-info">
        <div class="columns">
          <b-field label="Lønrapport (åben)" class="column is-2">
              <b-checkbox v-model="formAppUser.isSalaryReportOpen" type="checkbox"></b-checkbox>
          </b-field>
        </div>
      </section>
      <section class="domain-info">
        <div class="columns">
          <b-field label="Kreds" class="column is-2">
            <b-select v-model="circleId" expanded @input="filterCircle">
              <option
                v-for="(item, index) in circles"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Region" class="column is-2">
            <!-- TODO: Is this correct? -->

            <b-select v-model="regionFilter" expanded @input="filterRegions">
              <option
                v-for="(item, index) in regions"
                :key="index"
                :value="item.value"
              >
                {{ item.text }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Gruppe" class="column is-2">
            <!-- TODO: Is this correct? -->

            <b-select v-model="regionGroup" expanded @input="filterGroups">
              <option
                v-for="(item, index) in groups"
                :key="index"
                :value="item.id"
              >
                {{ item.title }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Order nummer" class="column is-2">
            <b-input v-model="formAppUser.orderNumber" type="number"></b-input>
          </b-field>
          <b-field label="Arbejdsbyrde" class="column is-2">
            <b-input v-model="formAppUser.workLoad" type="number"></b-input>
          </b-field>
          <b-field label="Nuværende rolle" class="column is-2">
            <b-input :value="getRole(userRole)" disabled />
          </b-field>
        </div>

        <div class="columns">
          <div v-for="(item, index) in formAppUser.weekdays" :key="index">
            <b-field :label="item.name" class="column is-2">
              <!-- TODO: Is this correct? -->
              <b-checkbox v-model="item.isChecked" type="checkbox"></b-checkbox>
            </b-field>
          </div>
        </div>
        <div class="grouping">
          <h2>Ansættelser</h2>
          <div style="text-align:right ">
            <b-button class="is-primary" @click="addEmptyEmployment"
              >Tilføj ny</b-button
            >
          </div>
          <b-table :data="employments">
            <b-table-column field="role" label="Rolle" v-slot="props">
              <b-select
                v-if="props.row.isEditing"
                v-model="props.row.role"
                placeholder="Vælg rolle"
                expanded
                required
              >
                <option v-for="role in roles" :key="role.key" :value="role.key">
                  {{ role.value }}
                </option>
              </b-select>
              <b-select
                v-if="!props.row.isEditing"
                v-model="props.row.role"
                placeholder="Vælg rolle"
                expanded
                required
                disabled
              >
                <option v-for="role in roles" :key="role.key" :value="role.key">
                  {{ role.value }}
                </option>
              </b-select>
            </b-table-column>

            <b-table-column field="fromDate" label="Fra dato" v-slot="props">
              <b-datepicker
                v-if="props.row.isEditing"
                v-model="props.row.fromDate"
                :focusedDate="props.row.fromDate"
                locale="da-DK"
                expanded
                required
                placeholder="Vælg en start dato"
              >
                <b-button
                  label="Idag"
                  type="small-margin is-primary"
                  @click="props.row.fromDate = new Date()"
                />
              </b-datepicker>
              <b-datepicker
                v-if="!props.row.isEditing"
                v-model="props.row.fromDate"
                :focusedDate="props.row.fromDate"
                locale="da-DK"
                expanded
                required
                disabled
                placeholder="Vælg en start dato"
              >
                <b-button
                  label="Idag"
                  type="small-margin is-primary"
                  @click="props.row.fromDate = new Date()"
                />
              </b-datepicker>
            </b-table-column>
            <b-table-column field="toDate" label="Til dato" v-slot="props">
              <b-datepicker
                v-if="props.row.isEditing"
                v-model="props.row.toDate"
                :focusedDate="props.row.toDate"
                locale="da-DK"
                expanded
                placeholder="Vælg en slut dato"
              >
                <b-button
                  label="Idag"
                  type="small-margin is-primary"
                  @click="props.row.toDate = new Date()"
                />
                <b-button
                  label="Fjern"
                  type="small-margin is-primary"
                  @click="props.row.toDate = undefined"
                />
              </b-datepicker>
              <b-datepicker
                v-if="!props.row.isEditing"
                v-model="props.row.toDate"
                :focusedDate="props.row.toDate"
                locale="da-DK"
                expanded
                disabled
                placeholder="Vælg en start dato"
              >
                <b-button
                  label="Idag"
                  type="small-margin is-primary"
                  @click="props.row.toDate = new Date()"
                />
              </b-datepicker>
            </b-table-column>
            <b-table-column field="edit" label="Rediger" v-slot="props">
              <b-button
                class="edit-buttons small-margin"
                v-if="props.row.isEditing === false"
                @click="editEmployment(props.row)"
                >Rediger</b-button
              >
              <b-button
                class="edit-buttons is-red small-margin"
                v-if="props.row.isEditing === false"
                @click="deleteEmployment(props.row)"
                >Slet</b-button
              >
              <b-button
                class="edit-buttons small-margin"
                v-if="props.row.isEditing || props.row.isEditing === true"
                @click="saveEmployment(props.row)"
                >Gem</b-button
              >
            </b-table-column>
          </b-table>
        </div>
      </section>

      <!-- Authentication -->
      <section class="authentication">
        <div class="columns">
          <b-field label="E-mail" class="column">
            <b-input v-model="formAppUser.email" type="email"></b-input>
          </b-field>
        </div>

        <div class="columns" v-if="hasEditRights" style="align-items: center;">
          <b-field label="Password" class="column">
            <b-input v-model="formAppUser.password" v-bind:disabled="!isNew" type="text"></b-input>
          </b-field>
          <b-button v-if="isAdmin && !isNew" style="margin-top:12px; padding:19.5px" @click="setPassword()">Ny password</b-button>
        </div>
      </section>

      <!-- Circles -->
      <section>
        <div class="columns">
          <div class="column">
            <b-field label="Kredse som ikke tæller før 07:15"> </b-field>
          </div>
          <div class="column is-3"></div>
        </div>

        <div class="columns">
          <div class="column">
            <b-select
              v-model="selectedCircle"
              placeholder="Vælg kreds"
              expanded
            >
              <option
                v-for="(item, index) in filteredCircles"
                :key="index"
                :value="item"
              >
                {{ item.title }}
              </option>
            </b-select>
          </div>

          <div class="column is-3">
            <b-button @click="addCircle" v-if="selectedCircle" expanded>
              Tilføj kreds
            </b-button>
          </div>
        </div>
        <b-table :data="formAppUser.circles">
          <b-table-column field="circleName" label="Kreds" v-slot="props">
            <span>{{ props.row.circleName }}</span>
          </b-table-column>

          <b-table-column field="action" label="Handling" v-slot="props">
            <b-button @click="removeCircle(props.row)" expanded>
              Fjern
            </b-button>
          </b-table-column>
        </b-table>
      </section>
      <!-- Buttons -->
      <div class="columns">
        <div class="column is-2" v-if="!newUser && hasEditRights">
          <b-button
            type="is-danger"
            @click="deleteUser"
            :loading="loading"
            expanded
          >
            Slet {{ formAppUser.givenName }}
          </b-button>
        </div>

        <div class="column"></div>
        <div class="column is-2">
          <b-button type="is-outline" @click="goBack" expanded>
            Afbryd
          </b-button>
        </div>
        <div class="column is-3" v-if="hasEditRights">
          <b-button
            :type="{ 'is-primary': !hasError, 'is-danger': hasError }"
            @click="submit"
            :loading="loading && !hasError"
            expanded
          >
            {{ newUser ? "Opret Bruger" : "Gem Ændringer" }}
          </b-button>
        </div>
      </div>
    </div>
    <confirmation-modal></confirmation-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, Store } from "vuex";
import ApiState from "../enums/APISTATE";
import moment from "moment";
import ConfirmationModal from "../components/calendar/ConfirmationModal.vue";

export default {
  name: "user-view",
  components: { ConfirmationModal },
  props: {
    userId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    formAppUser: {},
    roles: [
      { key: "Replacement", value: "Afløser" },
      { key: "User", value: "Inseminør" },
      { key: "Admin", value: "Administrator" },
    ],
    regions: [
      { value: "syd", text: "syd" },
      { value: "nord", text: "nord" },
      { value: "begge", text: "begge" },
      { value: "ingen", text: "ingen" },
    ],
    regionFilter: "syd",
    regionGroup: null,
    selectedCircle: null,
    circleId: null,
    employmentToDelete: null,
  }),
  async mounted() {
    await this.getAllGroups();
    await this.loadAllCircles();
    
    if(this.$route.name === "UserNew"){
      await this.setEmptyAppUser();
    } else {
      await this.loadAppUser(this.userId);
    }
    this.formAppUser = { ...this.appUser };
    this.regionFilter = this.formAppUser.region;
    this.regionGroup = this.formAppUser.groupId;
    this.circleId = this.formAppUser.circleId;
  },
  computed: {
    ...mapGetters("appUsers", ["appUserApiState", "appUser", "employments", "userRole"]),
    ...mapGetters("groupStore", ["groupApiState", "groups"]),
    ...mapGetters("circles", ["circleApiState", "circles"]),
    ...mapGetters(["currentUser", "isAdmin", "hasEditRights"]),
    ...mapGetters("confirmationModalStore", ["confirmed", "confirmingModel"]),
    loading() {
      return (
        this.appUserApiState !== ApiState.LOADED &&
        this.circleApiState !== ApiState.LOADED
      );
    },
    isNew(){
      return this.$route.name === "UserNew";
    },
    hasError() {
      return (
        this.appUserApiState === ApiState.ERROR ||
        this.circleApiState === ApiState.ERROR
      );
    },
    newUser() {
      return (
        Object.prototype.hasOwnProperty.call(this.formAppUser, "id") !== true
      );
    },
    filteredCircles() {
      if (this.circles) {
        return this.circles
          .filter((o) => o.title.toLowerCase().includes("kreds"))
          .filter((o) => !o.title.toLowerCase().includes("kreds 0"));
      }
      return this.circles;
    },
  },
  methods: {
    ...mapActions("appUsers", [
      "loadAppUser",
      "updateAppUser",
      "registerAppUser",
      "deleteAppUser",
      "addEmptyEmployment",
      "editEmployment",
      "saveEmployment",
      "setEmptyAppUser",
      "removeEmployment",
    ]),
    ...mapActions("confirmationModalStore", [
      "setErrorModalText",
      "setErrorModalOpen",
      "setConfirmationButtonText",
      "setErrorModalHeader",
      "setConfirmingModel",
      "setConfirmedAndClose",
    ]),
    ...mapActions("groupStore", ["getAllGroups"]),
    ...mapActions("circles", ["loadAllCircles"]),
    goBack() {
      this.$router.go(-1);
    },
    setPassword() {
      this.$router.push(`/configuration/users/${this.userId}/password`);
    },
    deleteEmployment(employment) {
      this.employmentToDelete = employment;
      this.setConfirmationButtonText("Bekræft");
      this.setErrorModalText(
        "Er du sikker på at du vil fjerne denne ansættelse"
      );
      this.setErrorModalHeader("Fjern ansættelse");
      this.setConfirmingModel(employment);
      this.setErrorModalOpen(true);
    },
    getRole(role) {
      if(this.roles.find((r) => r.key === role)) {
        return this.roles.find((r) => r.key === role).value;
      }
      return "Ukendt";
    },
    async deleteUser() {
      await this.deleteAppUser(this.formAppUser.id);

      if (this.appUserApiState === ApiState.ERROR) {
        return this.$buefy.dialog.alert({
          title: "Fejl",
          message: "Kunne ikke slette bruger",
          type: "is-danger",
        });
      }

      this.$buefy.dialog.alert({
        title: "Success",
        message: `${this.formAppUser.name} slettet`,
        type: "is-success",
        canCancel: false,
        onConfirm: () => this.$router.push("/configuration"),
      });
    },
    async submit() {
      if (this.newUser) {
        await this.registerAppUser(this.formAppUser);
      } else {
        await this.updateAppUser(this.formAppUser);
      }

      if (this.appUserApiState !== ApiState.ERROR) {
        this.$buefy.dialog.alert({
          title: "Success",
          message: `Bruger ${this.isNewUser ? "oprettet" : "opdateret"}`,
          type: "is-success",
          canCancel: false,
          onConfirm: () => this.$router.push("/configuration"),
        });
      } else {
        this.$buefy.dialog.alert({
          title: "Fejl",
          message: "Kunne ikke oprette bruger",
          type: "is-danger",
        });
      }
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD") !== "Invalid date"
        ? moment(date).format("YYYY-MM-DD")
        : "(Ikke sat)";
    },
    filterRegions(region) {
      this.regionFilter = region;
      this.formAppUser.region = region;
    },
    filterGroups(group) {
      this.regionGroup = group;
      this.formAppUser.groupId = group;
    },
    filterCircle(circleId) {
      this.circleId = circleId;
      this.formAppUser.circleId = circleId;
    },
    async removeCircle(item) {
      this.formAppUser.circles = this.formAppUser.circles.filter(
        (o) => o.circleId !== item.circleId
      );
    },
    async addCircle() {
      if (!this.formAppUser.circles) {
        this.formAppUser.circles = [];
      }

      if (
        !this.selectedCircle ||
        this.formAppUser.circles.find(
          (o) => o.circleId === this.selectedCircle.id
        )
      ) {
        return;
      }

      this.formAppUser.circles.push({
        employeeId: this.formAppUser.id,
        circleId: this.selectedCircle.id,
        employeeName: this.formAppUser.name,
        circleName: this.selectedCircle.title,
        _LatestUpdate: new Date(),
        _UpdateTag: this.formAppUser.id,
        _UpdatedBy: this.currentUser.id,
        _UpdatedByName: this.currentUser.name,
      });
      this.selectedCircle = null;
    },
  },
  watch: {
    confirmed(newValue) {
      if (newValue) {
        this.removeEmployment(this.confirmingModel);
        this.setConfirmedAndClose(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-view {
  .fake-control {
    min-height: 40px;
    padding: 3px;
  }
}

.small-margin {
  margin: 5px;
}

.no-border {
  border: 0px;
  box-shadow: none;
}

.grouping {
  border: 1px solid lightgrey;
  padding: 1rem;
  margin: 1rem 0px;
}

.edit-buttons {
  width: 100px;
}
</style>
